<template>
  <div
    class="riseup-header"
    :class="colorVariant"
  >
    <img
      class="margin-left-ml margin-top-m margin-bottom-m"
      :src="srcLogo"
    >
    <div
      v-if="showLogout"
      class="logout margin-top-sm margin-right-ml ri-glbl-large-body"
      @click="handleLogout"
    >
      Log out
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import riseupLogoIcon from '../../assets/riseup-logo.svg';
import riseupLogoIconWhite from '../../assets/riseup-logo-white.svg';

interface Props {
  colorVariant: string;
  logoColor?: string
  showLogout?: boolean
}
const props = defineProps<Props>();

const srcLogo = computed(() => (props.logoColor === 'white' ? riseupLogoIconWhite : riseupLogoIcon));

const handleLogout = async () => {
  // do nothing
};
</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';
@import '@riseupil/base-ui/src/scss/mixins';

  .riseup-header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba($riseup_gray_100, 0.15);

    .logout {
      color: $riseup_white;
    }
    &.yellow {
      background-color: $riseup_light_yellow;
    }
    &.beige {
      background-color: #FCF7ED;
    }
    &.green {
      background-color: $riseup_dark_green;
    }
    &.light-green {
      background-color: $riseup_green;
    }
  }
</style>
